module.exports = __webpack_public_path__ + "94c74eb1b11a98005db3a1cacb2e6705.svg";